import { Route, Switch } from 'react-router-dom';

import { AgendasSection } from '../agendas-section';
import { LlmDataProvider } from '../context/llm-data-context';
import { LLMEvaluations } from '../llm-evaluations';
import { LLMTraces } from '../llm-traces';
import { OverviewSection } from '../overview-section';
import { TrackingSection } from '../tracking-section';

export const Routes = () => {
  return (
    <Switch>
      <Route path='/admin' component={OverviewSection} exact />
      <Route path='/admin/overview' component={OverviewSection} exact />
      <Route path='/admin/tracking' component={TrackingSection} exact />
      <Route path='/admin/agendas' component={AgendasSection} exact />
      <LlmDataProvider>
        <Route path='/admin/llm-traces' component={LLMTraces} exact />
        <Route path='/admin/llm-evaluations' component={LLMEvaluations} exact />
      </LlmDataProvider>
    </Switch>
  );
};
